import React, { useState, useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './App.css';
// import "./assets/css/style_output.css"
import Layout from './components/Layout';
import Home from './pages/homePage';
import Products from './pages/productPage';
import ProductDetails from './pages/productDetails';
import About from './pages/About';
import Contact from './pages/Contact';
import ErrorPage from './pages/ErrorPage';
import Ecatalogue from './pages/Ecatalogue';

function App() {
  const [products, setProducts] = useState([]);
  const [fetchData, setFetchData] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('/data.json');
        const data = await response.json();
        setProducts(data.products);
        setFetchData(true);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout products={products} />,
      children: [
        { index: true, element: <Home /> },
        { path: 'products', element: <Products product={products} /> },
        { path: 'products/:id', element: <ProductDetails product={products} /> },
        { path: 'about', element: <About /> },
        { path: 'contact', element: <Contact product={products} /> },
        { path: 'e-catalogue', element: <Ecatalogue product={products} />}
      ],
      errorElement: <ErrorPage />
    }
  ]);

  return (
    <div className="bg-gray-100 min-h-screen">
      {fetchData && <RouterProvider router={router} />}
    </div>
  );
}

export default App;